import { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import {
  FiUser,
  FiShoppingBag,
  FiLogOut,
  FiBook,
  FiGift,
} from 'react-icons/fi';
import { BiWallet } from 'react-icons/bi';

import { useAuth } from '../../hooks/auth';
import ProModal from '../ProModal';
import CancelProModal from '../CancelProModal';
import Notification from '../Notification';

import { Container, MenuItem } from './styles';
import Button from '../Button';
import api from '../../services/api';

const CutterSideMenu = () => {
  const { signOut, loading } = useAuth();
  const [proModalOpen, setProModal] = useState(false);
  const [cancelProModalOpen, setCancelProModal] = useState(false);
  const [userPremium, setUserPremium] = useState(false);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        if (!loading) {
          const response = await api.get('/user_plan');
          setUserPremium(response.data.premium);
        }
        setLoading(false);
      } catch (err) {
        Notification({
          message: 'Erro ao carregar dados do usuário',
          type: Notification.types.ERROR,
        });
      }
    })();
  }, [loading]);

  function handleProButtonClick() {
    setProModal(true);
  }

  function handleProModalClose() {
    setProModal(false);
  }

  function handleCancelProButtonClick() {
    setCancelProModal(true);
  }

  function handleCancelProModalClose() {
    setCancelProModal(false);
  }

  function renderProButton() {
    if (userPremium) {
      return (
        <Button
          text="Cancelar assinatura"
          onClick={handleCancelProButtonClick}
          withIcon="star"
        />
      );
    }

    return (
      <Button
        text="Me tornar PRO"
        primary
        onClick={handleProButtonClick}
        withIcon="star"
      />
    );
  }

  return (
    <>
      <ProModal isOpen={proModalOpen} onClose={handleProModalClose} />
      <CancelProModal
        isOpen={cancelProModalOpen}
        onClose={handleCancelProModalClose}
      />
      <Container>
        <h2>Minha conta</h2>
        <ul>
          <MenuItem>
            <FiUser color="var(--accent)" size={20} />
            <NavLink to="/cutter/profile" activeClassName="active">Meus dados</NavLink>
          </MenuItem>
          <MenuItem>
            <FiShoppingBag color="var(--accent)" size={19} />
            <NavLink to="/cutter/projects" activeClassName="active">Meus projetos</NavLink>
          </MenuItem>
          <MenuItem>
            <FiBook color="var(--accent)" size={19} />
            <NavLink to="/cutter/courses" activeClassName="active">Meus cursos</NavLink>
          </MenuItem>
          <MenuItem>
            <BiWallet color="var(--accent)" size={20} />
            <NavLink to="/cutter/wallet" activeClassName="active">Minha carteira</NavLink>
          </MenuItem>
          <MenuItem>
            <FiGift color="var(--accent)" size={20} />
            <NavLink to="/cutter/indicate-a-friend" activeClassName="active">Indique um amigo</NavLink>
          </MenuItem>
          <MenuItem>
            <FiLogOut color="var(--accent)" size={20} />
            <Link to="/" onClick={signOut}>
              Sair do sistema
            </Link>
          </MenuItem>
        </ul>
        {!isLoading && renderProButton()}
      </Container>
    </>
  );
};

export default CutterSideMenu;
